// Component to render HTML preview safely
import React, { useRef, useEffect, useState } from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const PreviewContainer = styled(Paper)(({ theme }) => ({
  width: '100%',
  flex: 1,
  minHeight: 400,
  overflow: 'hidden',
  backgroundColor: '#fff',
  display: 'flex',
  flexDirection: 'column',
  boxShadow: theme.shadows[5]
}));

const HtmlPreview = ({ htmlContent }: { htmlContent: string }) => {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const [blobUrl, setBlobUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!htmlContent) {
      setBlobUrl((prev) => {
        if (prev) URL.revokeObjectURL(prev);
        return null;
      });
      return;
    }

    const blob = new Blob([htmlContent], { type: 'text/html; charset=utf-8' });
    const url = URL.createObjectURL(blob);
    setBlobUrl((prev) => {
      if (prev) URL.revokeObjectURL(prev);
      return url;
    });

    return () => URL.revokeObjectURL(url);
  }, [htmlContent]);

  return (
    <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
      {htmlContent ? (
        <PreviewContainer sx={{ flex: 1 }}>
          <iframe
            ref={iframeRef}
            title="HTML Preview"
            src={blobUrl || 'about:blank'}
            style={{
              width: '100%',
              flex: 1,
              minHeight: 350,
              border: 'none',
            }}
            sandbox="allow-same-origin allow-scripts"
          />
        </PreviewContainer>
      ) : (
        <PreviewContainer sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography variant="body1" color="textSecondary">
            Upload or paste HTML to see the preview
          </Typography>
        </PreviewContainer>
      )}
    </Box>
  );
};

export default HtmlPreview;
